// extracted by mini-css-extract-plugin
export default {"projects":"styles_projects__Ga62A","projectsDark":"styles_projectsDark__euptF","projectsLight":"styles_projectsLight__iE89V"};